import React from "react";
import ReactDatePicker, {registerLocale} from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import "./DateInput.css";

registerLocale("pt-BR", ptBR);

/**
 * Campo de data com calendário, substituto do <DatePicker> do element-react.
 *
 * Diferente do InputDate deste mesmo diretório — aquele é um campo do form-full e só
 * funciona dentro de um <FormFull>. Este é autônomo e mantém o mesmo contrato do
 * DatePicker que substituiu: recebe e devolve um **objeto Date em horário local**
 * (quem consome esses valores chama .toISOString(), .getMonth() e .getFullYear()).
 *
 * Não usamos <input type="date"> nativo porque ele exibe a data no formato do locale
 * do navegador — em um Chrome en-US sai mm/dd/yyyy, e não há como forçar dd/mm/yyyy.
 *
 * onChange recebe (name, date) — mesma assinatura dos handlers que já existiam.
 */
function DateInput({name, value, disabled, monthOnly, size, onChange, isClearable = true, ...props}) {
  return (
    <ReactDatePicker
      {...props}
      name={name}
      selected={value || null}
      onChange={(date) => onChange(name, date)}
      disabled={disabled}
      locale="pt-BR"
      dateFormat={monthOnly ? "MM/yyyy" : "dd/MM/yyyy"}
      placeholderText={monthOnly ? "mm/aaaa" : "dd/mm/aaaa"}
      showMonthYearPicker={Boolean(monthOnly)}
      isClearable={isClearable && !disabled}
      autoComplete="off"
      className={`form-control${size ? ` form-control-${size}` : ""}`}
      wrapperClassName="date-input-wrapper"
      // position:fixed evita que o calendário seja recortado pelo overflow de
      // modais e cards.
      popperProps={{strategy: "fixed"}}
    />
  );
}

export default DateInput;
